import { Injectable } from '@angular/core';
import { isServerSide } from '@tytapp/environment-utils';

@Injectable()
export class ViewportSize {
    width() {
        return isServerSide() ? 1920 : (window.screen?.width ?? window.innerWidth ?? 1920);
    }
}